import { X, FilterX, Filter } from "lucide-react";

import CustomButton from "@/components/desktop/button/CustomButton";
import styles from "./custom-applied-badge.module.scss";

const CustomAppliedBadges = ({ filters = [], onRemove, onClearAll, onOpen }) => {
	const visible = filters.filter((f) => f.visible !== false);

	const applied = [];
	for (const f of visible) {
		const v = f.value;
		const isEmptyArray = Array.isArray(v) && v.length === 0;
		const isEmptyString = v === "" || v === null || v === undefined;

		if (f.type === "switch") {
			if (typeof v === "boolean") {
				applied.push({ key: f.key, label: f.label, display: v ? "Sí" : "No", removable: true });
			}
		} else if (f.type === "select") {
			if (f.multiple) {
				if (isEmptyArray) continue;
				const map = new Map((f.options || []).map((o) => [o.value, o.label]));
				const labels = (v || []).map((val) => map.get(val) ?? String(val));
				if (labels.length) applied.push({ key: f.key, label: f.label, display: labels.join(", "), removable: true });
			} else {
				if (isEmptyString) continue;
				const label = (f.options || []).find((o) => o.value === v)?.label ?? String(v);
				applied.push({ key: f.key, label: f.label, display: label, removable: true });
			}
		} else if (f.type === "date") {
			if (isEmptyString) continue;
			applied.push({ key: f.key, label: f.label, display: v, removable: true });
		} else if (f.type === "number") {
			if (v === null || v === undefined || v === "") continue;
			applied.push({ key: f.key, label: f.label, display: String(v), removable: true });
		} else {
			if (isEmptyString) continue;
			applied.push({ key: f.key, label: f.label, display: String(v), removable: true });
		}
	}

	return (
		<div className={styles.wrap}>
			{applied.length > 0 && (
				<span className={styles.compactSummary}>
					<Filter size={14} />
					<span className={styles.compactSummaryLabel}>
						{applied.length} {applied.length === 1 ? "filtro activo" : "filtros activos"}
					</span>
					{onClearAll && (
						<button type="button" className={styles.compactClear} onClick={onClearAll} aria-label="Limpiar todos los filtros">
							<X size={14} />
						</button>
					)}
				</span>
			)}

			<div className={styles.scroller}>
				{applied.map((b) => (
					<span key={b.key} className={styles.badge} title={`${b.label}: ${b.display}`}>
						<strong className={styles.badgeKey}>{b.label}:</strong>
						<span className={styles.badgeVal}>{b.display}</span>
						<button className={styles.badgeClose} onClick={() => onRemove?.(b.key)} aria-label={`Quitar ${b.label}`}>
							<X size={14} />
						</button>
					</span>
				))}
			</div>

			<div>
				{onClearAll && (
					<CustomButton variant="secondary_outline" size="sm" startIcon={<FilterX size={16} />} onClick={onClearAll} style={{ marginRight: 8 }}>
						Limpiar todo
					</CustomButton>
				)}

				<CustomButton variant="secondary_outline" size="sm" startIcon={<Filter size={16} />} onClick={onOpen}>
					Filtros
				</CustomButton>
			</div>
		</div>
	);
};

export default CustomAppliedBadges;
